import type { z } from 'zod';
import { zs } from '@/entities/shared/schemas/zod';

export const shoppingStatusSchema = zs.enum(['pending', 'bought', 'discarded']);

export type ShoppingStatus = z.infer<typeof shoppingStatusSchema>;
